<template>
    <div>
        <h1>Accueil</h1>
        <p class="text-info">Bienvenue sur la plateforme de supervision Arkeon.</p>
        <b-row class="justify-content-center">
            <b-col cols="12" sm="8" md="6" lg="3">
                <b-link to="/gateways">
                    <b-card class="text-center">
                        <b-card-title>
                            <font-awesome-icon icon="broadcast-tower"/>
                        </b-card-title>
                        <b-card-text>
                            Passerelles
                        </b-card-text>
                    </b-card>
                </b-link>
            </b-col>
            <b-col cols="12" sm="8" md="6" lg="3">
                <b-link to="/devices">
                    <b-card class="text-center">
                        <b-card-title>
                            <font-awesome-icon icon="hdd"/>
                        </b-card-title>
                        <b-card-text>
                            Matériels
                        </b-card-text>
                    </b-card>
                </b-link>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: "Dashboard"
    }
</script>

<style scoped>

</style>